import { Link, useSearchParams } from "react-router-dom";
import { Cat, Dog, Bird, Fish, Flame, TrendingUp, Package, Percent } from "lucide-react";
import { useSettings } from "@/lib/hooks";

const MAIN = [
  { to: "/?cat=kedi", key: "kedi", label: "Kedi", icon: Cat },
  { to: "/?cat=kopek", key: "kopek", label: "Köpek", icon: Dog },
  { to: "/?cat=kus", key: "kus", label: "Kuş", icon: Bird },
  { to: "/?cat=balik", key: "balik", label: "Balık", icon: Fish },
  { to: "/?view=kampanya", key: "kampanya", label: "Kampanyalar", icon: Flame },
  { to: "/?view=cok-satan", key: "cok-satan", label: "Çok Satanlar", icon: TrendingUp },
];
const SUB = [
  { to: "/?type=Kuru Mama", label: "Kuru Mama" },
  { to: "/?type=Yaş Mama", label: "Yaş Mama" },
  { to: "/?view=toplu", label: "Çok Al Az Öde" },
  { to: "/?cat=kedi&view=kampanya", label: "Kedinize Özel Fırsatlar" },
  { to: "/?cat=kopek&view=kampanya", label: "Köpeğinize Özel Fırsatlar" },
  { to: "/?view=kargo-dahil", label: "Kargo Bizden" },
];

function Marquee() {
  const s = useSettings();
  const list = s?.marquee?.length ? s.marquee : ["Toplu alımlarda ekstra indirim"];
  const row = [...list, ...list, ...list];
  return (
    <div className="w-full max-w-7xl mx-auto px-4 lg:px-6 pt-4">
      <div className="w-full overflow-hidden rounded-md bg-[#DCFCE7] border border-[#BBF7D0]" data-testid="campaign-marquee">
        <div className="flex w-max animate-marquee py-2.5">
          {[...row, ...row].map((t, i) => (
            <span key={i} className="flex items-center gap-3 px-8 text-sm font-semibold text-[#14532D] whitespace-nowrap">
              <Percent className="h-4 w-4 text-[#16A34A]" /> {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function CategoryNav() {
  const [params] = useSearchParams();
  const active = params.get("cat") || params.get("view");
  return (
    <>
      <nav className="bg-[#172554] text-white" data-testid="category-nav">
        <div className="max-w-7xl mx-auto overflow-x-auto no-scrollbar snap-x">
          <div className="flex w-max mx-auto px-2">
            {MAIN.map(({ to, key, label, icon: Icon }) => (
              <Link key={key} to={to} data-testid={`nav-${key}`}
                className={`snap-start flex items-center gap-2 px-5 py-4 text-[15px] font-bold whitespace-nowrap border-b-2 transition-colors ${active === key ? "border-[#4ADE80] bg-white/10" : "border-transparent hover:bg-white/10"}`}>
                <Icon className="h-5 w-5" /> {label}
              </Link>
            ))}
          </div>
        </div>
      </nav>
      <div className="bg-[#E5E7EB]/70 border-b border-slate-200">
        <div className="max-w-7xl mx-auto overflow-x-auto no-scrollbar snap-x">
          <div className="flex w-max mx-auto px-2">
            {SUB.map((s) => (
              <Link key={s.label} to={s.to} data-testid={`subnav-${s.label}`}
                className="snap-start px-4 py-2.5 text-sm font-semibold text-[#172554] whitespace-nowrap hover:text-[#16A34A] flex items-center gap-1.5">
                {s.label === "Kargo Bizden" && <Package className="h-4 w-4" />} {s.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Marquee />
    </>
  );
}
